<script setup>
import { onMounted } from 'vue';
import { useAppointments } from '@store/appointments.js';
const $appointments = useAppointments();

import { useSettings } from '@store/settings';
const $settings = useSettings();

onMounted(async () => {
    await $appointments.cookiesAppointment('get')
    await $appointments.loadSelectedAppointment();
    await $settings.fetchSettings();
    $appointments.sortedRoutes;
    await $appointments.matchAppointmentPreRequirement();
});

import Service from '@views/booking/service/Index.vue';
import Staff from '@views/booking/staff/Index.vue';
import StaffProfile from '@views/booking/staff/StaffProfile.vue';
import Date from '@views/booking/date/Index.vue';
import Time from '@views/booking/time/Index.vue';
import Account from '@views/booking/account/Index.vue';
import Overview from '@views/booking/overview/Index.vue';
import Confirmation from '@views/booking/confirmation/Index.vue';
</script>

<template>
<div class="prebook-wrapper">
    <!-- <router-view /> -->
    <Service v-if="$appointments.activeStep == 'service'" />
    <Staff v-if="$appointments.activeStep == 'staff'" />
    <StaffProfile v-if="$appointments.activeStep == 'staff-profile'" />
    <Date v-if="$appointments.activeStep == 'date'" />
    <Time v-if="$appointments.activeStep == 'time'" />
    <Account v-if="$appointments.activeStep == 'account'" />
    <Overview v-if="$appointments.activeStep == 'overview'" />
    <Confirmation v-if="$appointments.activeStep == 'confirmation'" />
</div>
</template>